import { render, staticRenderFns } from "./popup-warehouse.vue?vue&type=template&id=187ad672&scoped=true"
import script from "./popup-warehouse.vue?vue&type=script&lang=js"
export * from "./popup-warehouse.vue?vue&type=script&lang=js"
import style0 from "./popup-warehouse.vue?vue&type=style&index=0&id=187ad672&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187ad672",
  null
  
)

export default component.exports